import React from "react";
import { styled } from "@mui/system";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  padding: "8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "20px",
  background: "#002035",
}));

const PriceAlertIcon = () => {
  return (
    <Wrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none">
        <g clipPath="url(#clip0_170_6476)">
          <path
            d="M6.34095 14.4839C6.34095 15.322 7.01905 16.0001 7.85714 16.0001C8.69524 16.0001 9.37333 15.322 9.37333 14.4839H6.34095ZM13.099 11.2916V6.85726C13.099 4.38107 11.3848 2.30869 9.06857 1.76012V1.21155C9.06857 0.541074 8.52762 0.00012207 7.85714 0.00012207C7.18667 0.00012207 6.64571 0.541074 6.64571 1.21155V1.76012C4.32952 2.30869 2.61524 4.38107 2.61524 6.85726V11.2916L1 12.9068V13.7144H14.7143V12.9068L13.099 11.2916ZM10.9048 8.38869H8.61905V10.6744H7.09524V8.38869H4.80952V6.85726H7.09524V4.57155H8.61905V6.85726H10.9048V8.38869Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_170_6476">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Wrapper>
  );
};

export default PriceAlertIcon;
